import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/logo.svg'
import _imports_1 from '../assets/images/icon-error.svg'
import _imports_2 from '../assets/images/icon-arrow.svg'


const _hoisted_1 = { class: "app-base-apparel-coming-soon" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Base Apparel Logo"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hero" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "accent" }, "We're"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "Coming"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "Soon")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, "Hello fellow shoppers! We're currently building our new fashion store. Add your email below to stay up-to-date with announcements and our launch deals.", -1)
const _hoisted_7 = { class: "form" }
const _hoisted_8 = { class: "controls" }
const _hoisted_9 = {
  key: 0,
  class: "validation-icon",
  src: _imports_1,
  alt: "Validation error icon"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Submit button icon"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "validation-errors"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailAddress) = $event)),
            placeholder: "Email Address",
            "aria-placeholder": "Email Address"
          }, null, 512), [
            [_vModelText, _ctx.emailAddress]
          ]),
          (!_ctx.isValid)
            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signup && _ctx.signup(...args)))
          }, _hoisted_11)
        ]),
        (!_ctx.isValid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Please provide a valid email"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}